// extracted by mini-css-extract-plugin
export var accordion = "AccordionModule-module--accordion--017c2";
export var accordionsContainer = "AccordionModule-module--accordionsContainer--5310a";
export var contentContainer = "AccordionModule-module--contentContainer--d7790";
export var title = "AccordionModule-module--title--45187";